import React, { Component } from 'react';
//import {getConfig} from '../../config.js';
//import Slider from 'react-slick';
import Imagecard from '../Imagecard/Imagecard.js'
import {Gallery} from '../Gallery/Gallery.js'
import {Carousel} from '../Carousel/Carousel.js'
import {Videoplayer} from '../Videoplayer/Videoplayer.js'

import './Modularcontent.scss';

export class Modularcontent extends Component {

  constructor(props) {
    super(props);
    this.state = { data: {} };
  }

  componentDidMount() {
  }

  render() {

    const content = this.props.content;
    const type = content.acf_fc_layout;

    const settings = {
      dots: false,
      arrows: true,
      infinite: false,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode : true,
      centerPadding : '90px',
      variableWidth : true,
      responsive: [
        {
          breakpoint: 1999,
          settings: {
            centerPadding : '20px'
          }
        },
        {
          breakpoint: 680,
          settings: 'unslick'
        }
      ]
    };

    switch (type) {
      case 'worksingle_content_carousel':
        let carouselMedia = content.worksingle_content_carousel_items;
        const imagesRows = carouselMedia.reduce(function (rows, key, index) {
            return (index % 2 == 0 ? rows.push([key])
              : rows[rows.length-1].push(key)) && rows;
          }, []);

        return (
          <div className="module__body__content module__body__content--2">
            <div className="module__body__content__inner">
              <div className="module__body__content__section module__body__content__section--fullwidth module__body__content__section--fullwidth--devicewidth">
                <Carousel type="media" settings={settings}>
                  {imagesRows && imagesRows.map((imageRow, index) => {

                    return (
                      <div className="slider__row" key={index}>
                        {imageRow.map((item, index2) => {
                          return (
                            <div className="slider__item" key={index2}>
                              {item.worksingle_content_carousel_items_media_type === 'image' &&
                                <Imagecard image={item.worksingle_content_carousel_items_img.url} alt="" />
                              || item.worksingle_content_carousel_items_media_type === 'video' &&
                                <a
                                  srl_video_thumbnail={item.worksingle_content_carousel_items_img.url}
                                  srl_video_loop="false"
                                  srl_video_scale="80"
                                  srl_video_caption=""
                                  href={item.worksingle_content_carousel_items_video_url}
                                  className="slider__item__link"
                                >
                                  <img src={item.worksingle_content_carousel_items_img.url} alt="" />
                                </a>
                                || item.worksingle_content_carousel_items_img.type === 'video' &&
                                <Videoplayer url={item.worksingle_content_carousel_items_img.url} loop={true} controls={false} autoplay={true} />
                              }
                            </div>
                          )
                        })}
                      </div>
                    )
                  })}
                </Carousel>
              </div>
            </div>
          </div>
        )

        break;
      case 'worksingle_content_image_fullwidth':
        let type = content.worksingle_content_image_fullwidth_img.type;
        let src = content.worksingle_content_image_fullwidth_img.url;
        let alt = content.worksingle_content_image_fullwidth_img.alt;
        let ratio = content.worksingle_content_image_fullwidth_img_image_format
        return (
          <div className="module__body__content module__body__content--2">
            <div className="module__body__content__inner">
              <div className="module__body__content__section module__body__content__section--fullwidth">
                {type === 'image' &&
                  <Imagecard image={src} alt={alt} ratio={ratio} />
                }
                {type === 'video' &&
                  <Videoplayer url={src} loop={true} ratio={ratio} controls={false} autoplay={true} />
                }
              </div>
            </div>
          </div>
        )
        break;
      case 'worksingle_content_video_fullwidth':

        let videourl = content.worksingle_content_video_fullwidth_url;
        let videopreview = (content.worksingle_content_video_fullwidth_preview) ? content.worksingle_content_video_fullwidth_preview.url : false;
        return (
          <div className="module__body__content module__body__content--2">
            <div className="module__body__content__inner">
              <div className="module__body__content__section module__body__content__section--fullwidth">
                <Videoplayer url={videourl} preview={videopreview} loop={false} controls={true} />
              </div>
            </div>
          </div>
        )
        break;
      case 'worksingle_content_textual_content':

        let position = content.worksingle_content_textual_content_position;
        let textualcontent = content.worksingle_content_textual_content_wysiwyg;
        return (
          <div className="module__body__content module__body__content--2">
            <div className="module__body__content__inner">
              <div className="module__body__content__section module__body__content__section--1">
              {position === 'left' &&
                <div className="htmlcontent htmlcontent--2" dangerouslySetInnerHTML={{__html: textualcontent}} />
              }
              </div>
              <div className="module__body__content__section module__body__content__section--2">
                {position === 'right' &&
                  <div className="htmlcontent htmlcontent--2" dangerouslySetInnerHTML={{__html: textualcontent}} />
                }
              </div>
            </div>
          </div>
        )
        break;
      case 'worksingle_content_gallery':

        let galleryImagesArr = [];
        let galleryImages = content.worksingle_content_gallery_items.map((item, index) => {
          let typeFile = (typeof item.worksingle_content_gallery_items_img !== 'undefined') ? item.worksingle_content_gallery_items_img.type : 'image';
          let type = (typeFile === 'video') ? 'videouploaded' : item.worksingle_content_gallery_items_type;
          let src = (item.worksingle_content_gallery_items_img) ? item.worksingle_content_gallery_items_img.url : false;
          let videourl = (type == 'video') ? item.worksingle_content_gallery_items_video_url : (type == 'videouploaded') ? item.worksingle_content_gallery_items_img.url : false;
          let ratio = item.worksingle_content_gallery_items_img_image_format;
          let alt = "";
          galleryImagesArr.push({type: type, src: src, alt: alt, videourl: videourl, ratio: ratio});
        })
        let cols = content.worksingle_content_gallery_columns;

        let title = content.worksingle_content_gallery_title;

        return (

          <div className="module__body__content module__body__content--2">
            <div className="module__body__content__inner">
              <div className="module__body__content__section module__body__content__section--fullwidth">
                {title &&
                  <h3 className="module__body__content__section__title">{title}</h3>
                }
                <Gallery cols={cols} innercontent={galleryImagesArr}></Gallery>
              </div>
            </div>
          </div>
        )
        break;
      default:
        return (
          <div />
        )
        break;
    }


  }

}
